import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { Observable } from "rxjs";
import {
  Service,
  ServiceCreate,
  ServiceUpdate
} from "src/app/backend/models/service";
import { UserNotify } from "src/app/support/notify-decorator";
import { PageRequest } from "src/app/support/page-request";
import { PaginatedResult } from "src/app/support/paginated-result";
import { environment } from "src/environments/environment";

@Injectable()
export class ServiceBackend {
  readonly #http = inject(HttpClient);

  list(request: PageRequest): Observable<PaginatedResult<Service>> {
    return this.#http.get<PaginatedResult<Service>>(
      `${environment.snoots.api.healthcare}/services`,
      {
        params: {
          p: request.page,
          s: request.pageSize
        }
      }
    );
  }

  @UserNotify({
    successMessage: marker("Servizio creato"),
    errorMessage: marker("Impossibile creare il servizio")
  })
  create(request: ServiceCreate): Observable<void> {
    return this.#http.post<void>(
      `${environment.snoots.api.healthcare}/services`,
      request
    );
  }

  @UserNotify({
    successMessage: marker("Servizio aggiornato"),
    errorMessage: marker("Impossibile aggiornare il servizio")
  })
  update(id: string, request: Partial<ServiceUpdate>): Observable<void> {
    return this.#http.patch<void>(
      `${environment.snoots.api.healthcare}/services/${id}`,
      request
    );
  }

  @UserNotify({
    successMessage: marker("Servizio eliminato"),
    errorMessage: marker("Impossibile eliminare il servizio")
  })
  delete(id: string): Observable<void> {
    return this.#http.delete<void>(
      `${environment.snoots.api.healthcare}/services/${id}`
    );
  }
}
